/**
 * Determines if a user is allowed to interact with the navigational breadcrumbs in FWG
 * by checking against a list of blacklisted content owner account IDs.
 *
 * @param {Object} contentOwner The current signed in account
 */
export const hasNavigationalAccess = contentOwner => {
  const blacklistedAccountIds = [
    // Moondance Adventures account ID in Prod:
    '1MhpPB4z2WacKtDMp86j81i',
  ];

  return !blacklistedAccountIds.includes(contentOwner?.id);
};
